// Auth routes
export const LOG_OUT = "auth/logout";
export const LOGIN = "auth/local/signin";
export const SIGNUP = "auth/local/signup";
export const LOGIN_SUCCESS_URL = "auth/login/success";

export const GET_USER = "/user";
export const FORGOT_PASSWORD = "/forgotPassword";
export const RESET_PASSWORD = "/resetPassword";
export const UPDATE_PASSWORD = "/users/:id/password-update";
/**
 * Settings
 */

export const TESCOM_USER_DATA = "TESCOM_USER_DATA";
export const USER_PROFILE_TAG = "user-profile";
export const UPDATE_USER = "/update_user";
export const UPDATE_USER_PROFILE = "/user";
export const PUBLIC_REQUEST_KEY = "public-request";
export const SCHOOLS_TAG =  "SCHOOLS"
export const USERS_TAG = "USERS"
// Request Status

export const RESPONSE_SUCCESS = "SUCCESS";
export const RESPONSE_ERROR = "FAILURE";

export const UPLOAD_IMAGE = "upload/upload-image";
export const IMAGE_TAG = "user-image";
